var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container container_40 trade-orders" },
    [
      _c("buy-order", {
        staticClass: "trade-orders__item",
        attrs: { assets: _vm.assets }
      }),
      _vm._v(" "),
      _c("sell-order", {
        staticClass: "trade-orders__item",
        attrs: { assets: _vm.assets }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42251350", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42251350","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/trade/index/components/tradeOrders/Trade.TradeOrders.vue
// module id = sVgO
// module chunks = 1